import { create } from 'zustand';

/**
 * A tiny global "flash the page" signal. Domina Agent bumps `tick` when she
 * takes you somewhere (e.g. a tour "Show me"), and <PageHighlight> flashes a
 * pink border around the page — so even navigating to the page you're already
 * on gives clear visual feedback that she's highlighting it.
 */
interface HighlightState {
  tick: number;
  flash: () => void;
}

export const useHighlightStore = create<HighlightState>((set) => ({
  tick: 0,
  flash: () => set((s) => ({ tick: s.tick + 1 })),
}));
